module.exports = __webpack_public_path__ + "img/app_store.a111d976.svg";